export default __webpack_public_path__ + "static/media/05_prirozene-zmlazeni.52c54641.jpg";